// extracted by mini-css-extract-plugin
export default {"promo-box":"_1qddir3","promoBox":"_1qddir3","promo-box-resize-detector-wrapper":"_1od1zhj","promoBoxResizeDetectorWrapper":"_1od1zhj"};